/**
 * PUCT registered-broker wording (CLO Registered_Broker_Wording.md, 2026-10-10). Exact approved strings only.
 *
 * Registration facts are Owner-supplied (confirmed twice by the Owner): RateCurrent LLC, PUCT broker registration
 * BR260240, approved 2026-10-06. No public PUCT list was available to cross-check; the Owner's confirmation is
 * treated as the verification. Set PUCT_REGISTRATION_VERIFIED to false to remove every registration string at once.
 *
 * Placement: the footer line (identity sentence + registration number) renders in the site-wide footer on every public
 * route (Owner order 2026-10-15, supersedes CLO 4.1 "no number in footer"); S3 (long form) stays on the Terms of Use page.
 * Never in titles, meta, Open Graph, JSON-LD, headings, hero copy, answer pages, llms.txt or sitemap text.
 * This file is the single source of truth for the registration number.
 * Do not add compensation lines (Line A / Line B) here; they are deferred until payments or plan results exist.
 */
export const PUCT_REGISTRATION_VERIFIED = true;

export const PUCT_REGISTERED_NAME = "RateCurrent LLC";
export const PUCT_BROKER_REGISTRATION_NUMBER = "BR260240";

/** Footer line, part 1: identity sentence. */
export const REGISTERED_BROKER_FOOTER_IDENTITY = `${PUCT_REGISTERED_NAME} is a PUCT-registered broker.`;
/** Footer line, part 2: kept together on one line when the footer wraps. */
export const REGISTERED_BROKER_FOOTER_NUMBER = `Registration No. ${PUCT_BROKER_REGISTRATION_NUMBER}`;
/** Full footer line (one line of text; the two parts are joined by a single space). */
export const REGISTERED_BROKER_FOOTER_LINE = `${REGISTERED_BROKER_FOOTER_IDENTITY} ${REGISTERED_BROKER_FOOTER_NUMBER}`;

/** S3: Terms of Use identity line (long, with number). */
export const REGISTERED_BROKER_LEGAL_LINE =
  `${PUCT_REGISTERED_NAME} is registered with the Public Utility Commission of Texas as a broker, registration number ${PUCT_BROKER_REGISTRATION_NUMBER}.`;
